__turbopack_context__.v({
  "pagination": "dots-pagination-module-scss-module__f7ieBW__pagination",
  "paginationItem": "dots-pagination-module-scss-module__f7ieBW__paginationItem",
  "paginationItemActive": "dots-pagination-module-scss-module__f7ieBW__paginationItemActive",
});
